import API from '@/lib/API';
const RESOURCE_URL = '/material-returns';

export const materialReturnService = {
  createReturn: async (data) => {
    const response = await API.post(RESOURCE_URL, data);
    return response;
  },

  getProjectReturns: async (projectId, page = 1, limit = 5) => {
    const response = await API.get(`${RESOURCE_URL}/project/${projectId}?page=${page}&limit=${limit}`);
    return response;
  },

  listAllReturns: async (page = 1, limit = 15, type = 'ALL', search = '', startDate = null, endDate = null) => {
    let url = `${RESOURCE_URL}?page=${page}&limit=${limit}&type=${type}`;
    if (search) url += `&search=${encodeURIComponent(search)}`;
    if (startDate) url += `&startDate=${startDate}`;
    if (endDate) url += `&endDate=${endDate}`;
    const response = await API.get(url);
    return response;
  },

  getSiteInventory: async (projectId) => {
    const response = await API.get(`${RESOURCE_URL}/site-inventory/${projectId}`);
    const payload = response.data ?? response;
    if (Array.isArray(payload)) return payload;
    if (Array.isArray(payload?.items)) return payload.items;
    return [];
  },

  updateStatus: async (id, status) => {
    const response = await API.patch(`${RESOURCE_URL}/${id}/status`, { status });
    return response;
  },

  updateReturnPayment: async (id, data) => {
    const response = await API.patch(`${RESOURCE_URL}/${id}/payment`, data);
    return response;
  },
  
  restockReturn: async (id, data) => {
    const response = await API.post(`${RESOURCE_URL}/${id}/restock`, data);
    return response;
  }
};
